import React, { ReactElement, VFC } from 'react';
import { EditorConfirmPanel, EditorConfirmPanelProps } from 'src/editor/confirm-panel';

export interface StepEditorWarningPanelProps
  extends Pick<
    EditorConfirmPanelProps,
    'renderOrigin' | 'onOpen' | 'onClose' | 'disableConfirmButton' | 'closeRef' | 'openRef'
  > {
  copy: ReactElement;
  showBackButton?: boolean;
  confirmCopy: string;
  denyCopy: string;
  onConfirm: () => void;
  onDeny: () => void;
}

export const StepEditorWarningPanel: VFC<StepEditorWarningPanelProps> = ({ showBackButton = false, ...props }) => {
  return (
    <EditorConfirmPanel
      openAfterMount={false}
      {...props}
      hasBackButton={showBackButton}
      confirmButtonClassName='btn-bedrock-primary'
    />
  );
};
